var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2001 20.8V16C35.2001 15.1168 35.9169 14.4 36.8001 14.4H42.9713L42.4305 13.1392C41.9265 11.9632 40.7697 11.2 39.4897 11.2H4.8001C3.0321 11.2 1.6001 12.632 1.6001 14.4V36.8H6.4801C6.3457 36.1376 6.3713 35.4192 6.6193 34.6784C7.0385 33.4256 8.1153 32.4336 9.3985 32.1216C12.0417 31.48 14.4001 33.464 14.4001 36C14.4001 36.2736 14.3713 36.5408 14.3201 36.8H35.2801C35.0577 35.7024 35.2737 34.448 36.2129 33.1984C36.3361 33.0816 36.4689 32.9568 36.5937 32.8384C39.8033 30.7088 43.2001 32.9568 43.2001 36C43.2001 36.2736 43.1713 36.5408 43.1201 36.8H46.4001V25.6C46.4001 23.832 44.9681 22.4 43.2001 22.4H36.8001C35.9169 22.4 35.2001 21.6832 35.2001 20.8Z",
    fill: "#22428F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 32C38.1393 32 37.1219 32.4214 36.3718 33.1716C35.6216 33.9217 35.2002 34.9391 35.2002 36C35.2002 37.0609 35.6216 38.0783 36.3718 38.8284C37.1219 39.5786 38.1393 40 39.2002 40C40.2611 40 41.2785 39.5786 42.0286 38.8284C42.7788 38.0783 43.2002 37.0609 43.2002 36C43.2002 34.9391 42.7788 33.9217 42.0286 33.1716C41.2785 32.4214 40.2611 32 39.2002 32Z",
    stroke: "#FFD708",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3999 32C9.33904 32 8.32162 32.4214 7.57148 33.1716C6.82133 33.9217 6.3999 34.9391 6.3999 36C6.3999 37.0609 6.82133 38.0783 7.57148 38.8284C8.32162 39.5786 9.33904 40 10.3999 40C11.4608 40 12.4782 39.5786 13.2283 38.8284C13.9785 38.0783 14.3999 37.0609 14.3999 36C14.3999 34.9391 13.9785 33.9217 13.2283 33.1716C12.4782 32.4214 11.4608 32 10.3999 32Z",
    stroke: "#FFD708",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 35.2H4.8001M44.8001 35.2H46.4001H44.8001Z",
    stroke: "#FFD708",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.e40fee6c7242c72f595863e195b27a0b.svg";
export { ForwardRef as ReactComponent };